import { slugify } from './slug';

/** Region segment in URL (e.g. gb). Avoid treating app routes as regions. */
export function regionPrefix(region) {
  if (!region || typeof region !== 'string') return '';
  const r = region.toLowerCase();
  if (['search', 'movies', 'tv', 'anime'].includes(r)) return '';
  if (/^[a-z]{2}$/.test(r)) return `/${r}`;
  return '';
}

export function detailPath(category, tmdbId, title, regionPrefix = '', slugOverride = '') {
  const slug = String(slugOverride || '').trim() || slugify(title);
  const p = regionPrefix ? `/${regionPrefix}` : '';
  switch (category) {
    case 'movie':
      return `${p}/movies/${tmdbId}-${slug}`;
    case 'tv':
      return `${p}/tv/${tmdbId}-${slug}`;
    case 'anime_movie':
      return `${p}/anime/movies/${tmdbId}-${slug}`;
    case 'anime_tv':
      return `${p}/anime/tv/${tmdbId}-${slug}`;
    default:
      return `${p}/movies/${tmdbId}-${slug}`;
  }
}

export function similarPath(category, tmdbId, title, regionPrefix = '', slugOverride = '') {
  return `${detailPath(category, tmdbId, title, regionPrefix, slugOverride)}/similar`;
}

/** Parse :idSlug segment (e.g. "155-the-dark-knight") into { id, slug } */
export function parseIdSlug(idSlug) {
  if (!idSlug || typeof idSlug !== 'string') return { id: null, slug: '' };
  const idx = idSlug.indexOf('-');
  if (idx <= 0) return { id: idSlug, slug: '' };
  return { id: idSlug.slice(0, idx), slug: idSlug.slice(idx + 1) };
}
